import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'
import { TeamTree, type TeamTreeNode } from './_components/TeamTree'
import { CreateTeamSheet } from './_components/CreateTeamSheet'
import { EditTeamSheet } from './_components/EditTeamSheet'

interface TeamsIndexProps {
  teams: TeamTreeNode[]
  all_teams_flat: { id: number; name: string }[]
}

export default function TeamsIndex({ teams, all_teams_flat }: TeamsIndexProps) {
  const [createOpen, setCreateOpen] = useState(false)
  const [createParentId, setCreateParentId] = useState<number | undefined>()
  const [editTeam, setEditTeam] = useState<TeamTreeNode | null>(null)

  function handleCreate(parentId?: number) {
    setCreateParentId(parentId)
    setCreateOpen(true)
  }

  function handleEdit(team: TeamTreeNode) {
    setEditTeam(team)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Teams</h1>
          <p className="text-muted-foreground">
            Manage your organization's team hierarchy.
          </p>
        </div>
        <Button onClick={() => handleCreate()}>
          <Plus className="mr-2 size-4" />
          Create Team
        </Button>
      </div>

      <div className="rounded-lg border bg-card p-4">
        <TeamTree
          teams={teams}
          onEdit={handleEdit}
          onCreate={handleCreate}
        />
      </div>

      <CreateTeamSheet
        open={createOpen}
        onOpenChange={setCreateOpen}
        teams={all_teams_flat}
        parentId={createParentId}
      />

      <EditTeamSheet
        team={editTeam}
        onOpenChange={(open) => { if (!open) setEditTeam(null) }}
      />
    </div>
  )
}
